export default function (umbrella) {
  var requestMiddleware = [];
  function applyRequestMiddleware(fn) {
    requestMiddleware.push(fn);
  }
  function clientFetch(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    requestMiddleware.forEach(function (fn) {
      fn(url, options);
    });
    return fetch(url, options);
  }
  umbrella.fetch = clientFetch;
  umbrella.applyRequestMiddleware = applyRequestMiddleware;
}
//# sourceMappingURL=fetch.js.map